export default __webpack_public_path__ + "static/mouse2-78b44541761b4c9ad74603359b024025.mp4";